<div class="confirmation-dialog" [class.confirmation-dialog--detailed]="isDetailedLayout">
  <div class="confirmation-dialog__content">
    <!-- Detailed Layout: Title + Description -->
    <div *ngIf="isDetailedLayout" class="confirmation-dialog__header">
      <h2 class="confirmation-dialog__title">{{ data.title! | translateLang }}</h2>
      <p class="confirmation-dialog__description">{{ data.description! | translateLang: data.params }}</p>
    </div>

    <!-- Simple Layout: Message -->
    <p *ngIf="!isDetailedLayout" class="confirmation-dialog__message">
      {{ data.message! | translateLang: data.params }}
    </p>

    <!-- Action Buttons -->
    <div class="confirmation-dialog__actions" [class.confirmation-dialog__actions--single]="data.hideCancelButton">
      <button
        *ngIf="!data.hideCancelButton"
        class="confirmation-dialog__button confirmation-dialog__button--cancel"
        (click)="onCancel()"
        type="button"
      >
        {{ data.cancelButtonText! | translateLang }}
      </button>
      <button
        [class]="'confirmation-dialog__button ' + (data.hideCancelButton ? 'confirmation-dialog__button--ok' : confirmButtonClass)"
        (click)="onConfirm()"
        type="button"
      >
        {{ data.confirmButtonText! | translateLang }}
      </button>
    </div>
  </div>
</div>
